var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveBgPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.2675 9.88622L22.1138 8.73254C21.645 8.2631 21.0094 8 20.3462 8H10.7188C9.76939 8 9 8.76939 9 9.71879V21.2812C9 22.2306 9.76939 23 10.7188 23H22.2812C23.2306 23 24 22.2306 24 21.2812V11.6538C24 10.9906 23.7369 10.355 23.2675 9.88622ZM11.5 11.9062V10.3438C11.5 10.085 11.71 9.875 11.9687 9.875H18.5312C18.79 9.875 19 10.085 19 10.3438V11.9062C19 12.165 18.79 12.375 18.5312 12.375H11.9687C11.71 12.375 11.5 12.165 11.5 11.9062ZM16.5 20.5C14.9469 20.5 13.6875 19.2406 13.6875 17.6875C13.6875 16.1343 14.9469 14.875 16.5 14.875C18.0531 14.875 19.3125 16.1343 19.3125 17.6875C19.3125 19.2406 18.0531 20.5 16.5 20.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(9 8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBgPrimary);
export default __webpack_public_path__ + "static/media/saveBGPrimary.ebc3e1ee.svg";
export { ForwardRef as ReactComponent };